import React from 'react';
import { Link } from 'react-router-dom';
import { Checkbox } from '../../widgets/beauty/input';

import './Node.scss';

export type NodeType = 'sensor' | 'group' | '';

export interface NodeRowProps {
  id: string;
  type: NodeType;
  text: string | React.ReactElement;
  checked?: boolean;
  onCheck?: (id: any, type: string) => void;
  onClick?: (id: any, type: string) => void;
  noCheckbox?: boolean;
  meta?: string;
  metaClasses?: string;
  query?: string;
}

export const NodeRow = (props: NodeRowProps) => {
  const { id, text, type, checked, noCheckbox, meta, metaClasses } = props;
  let { onCheck, onClick } = props;
  if (onCheck) {
    onCheck = onCheck.bind(this, id, type);
  }
  if (onClick) {
    onClick = onClick.bind(this, id, type);
  }

  let icon = '';
  if (type === 'group') {
    icon = 'fas fa-folder';
  }
  else if (type === 'sensor') {
    icon = 'fad fa-sensor';
  }

  const rowContent = (
    <>
      <span className={`row-icon ${type}-icon`}><i className={icon}></i></span>
      <span className="node-name">{text}</span>
    </>
  );

  return (
    <div className="cmp-node-row">
      <div className={'main-row' + (!meta ? ' py-0' : '')}>
        {(!noCheckbox) ? (
          <Checkbox
            text=""
            checked={checked}
            onChange={onCheck as any}
          />
        ) : ''}
        {type === 'group' ?
          (<Link
            onClick={onClick as any}
            to={{ pathname: `/dashboard/edit-groups/${id}`, search: props.query }}
            className="row-content clickable">{rowContent}</Link>) :
          (<div className="row-content clickable">{rowContent}</div>)
        }
      </div>
      {(meta) ? (<div className={'meta ' + (metaClasses ?? '')}>{meta}</div>) : ''}
    </div>
  );
}
